import Swiper, { Autoplay, Navigation, EffectFade } from 'swiper';
import SliderBase from './slider-base';

const SLIDER_DELAY = 10000;

export default class SliderHero extends SliderBase {
    static initAll() {
        const swiperContainer = document.querySelector('.slider-hero-enabled.swiper');

        if (swiperContainer === null) return;
        
        const config = {
            modules: [Navigation, Autoplay, EffectFade],
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            allowTouchMove: false,
            speed: 1500, 
            autoplay: {
                delay: SLIDER_DELAY,
                disableOnInteraction: false,
            },
        };

        const swiper = new Swiper(swiperContainer, config);

        this.initProgressbar(swiper, SLIDER_DELAY);

        swiper.on('slideChangeTransitionEnd', () => {
            this.resetProgressbars(swiper);
            this.initProgressbar(swiper, SLIDER_DELAY);
        });
    }

    static initProgressbar(swiper, delayMs)    {
        const delaySeconds = delayMs / 1000;
        const swiperDOM = swiper.el;
        const activeSlide = swiperDOM.querySelector(".swiper-slide-visible");
        const activeProgressbar = activeSlide.querySelector('.progress-bar');

        activeProgressbar.setAttribute('style', 'transition: width ease-in-out ' + delaySeconds + 's; width: 100%;');
    }

    static resetProgressbars(swiper)    {
        const swiperDOM = swiper.el;
        const progressbars = swiperDOM.querySelectorAll('.progress-bar');

        progressbars.forEach((bar) => {
            bar.setAttribute('style', 'transition: none;width: 0;');
        });
    }
    
    constructor(container) {
        this.container = container;
        this.config = {
            modules: [Navigation],
        };

        super(this.container, this.config);
    }
}